import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { IConfirmAction, confirmAction, hideAction, IConfirmStoreState } from '@/redux/ui/confirm';

interface IProps {
    text: string;
    type?: number;
    visible: boolean;
    hideAction(): void;
    confirmAction(): void;
    confirm?: string;
    cancel?: string
};

class Confirm extends React.Component<IProps, any> {
    constructor(props: any) {
        super(props);
    }
    public render() {
        return (
            <div className={`ui-popup ${this.props.visible ? 'active' : ''}`}>
                <div className="ui-popup-content">
                    <div className="ui-popup-body" dangerouslySetInnerHTML={{__html: this.props.text}}></div>
                    <div className="ui-popup-footer">
                        {
                            this.props.type === 0 ?
                            <span className="ui-popup-cancel" onClick={() => this.props.hideAction()}>{this.props.cancel}</span> : null
                        }
                        <span className="ui-popup-confirm" onClick={() => this.props.confirmAction()}>{this.props.confirm}</span>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = ( state: any ): IConfirmStoreState => {
    return {
        ...state.uiConfirmReducers
    };
};

const mapDispatchToProps = ( dispatch: Dispatch<IConfirmAction> ) => {
    return bindActionCreators({ confirmAction, hideAction }, dispatch);
};

export default connect( mapStateToProps, mapDispatchToProps )(Confirm);